// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises */

import * as types from "./actionTypes";
import * as userLicenseApi from "../../apis/userLicenseApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

/*
 *  Action Creators
 *
 */
export function getUserLicensesSuccess() {
	return { type: types.LICENSES_GET_USER_LICENSES };
}

export function addUserLicenseSuccess() {
	return { type: types.LICENSES_ADD_USER_LICENSE };
}

export function updateUserLicenseSuccess() {
	return { type: types.LICENSES_UPDATE_USER_LICENSE };
}

export function removeUserLicenseSuccess() {
	return { type: types.LICENSES_REMOVE_USER_LICENSE };
}

/*
 *  Thunks
 *
 */
export function getUserLicenses(accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return userLicenseApi
				.getUserLicenses(accessToken)
				.then((res) => {
					dispatch(getUserLicensesSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function addUserLicense(accessToken, userLicense) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return userLicenseApi
				.addUserLicense(accessToken, userLicense)
				.then((res) => {
					dispatch(addUserLicenseSuccess());
					return userLicenseApi
						.clearAuthCachesInDataPlatform(accessToken, userLicense.clientId)
						.then(() => resolve(res));
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function updateUserLicense(accessToken, userLicense) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return userLicenseApi
				.updateUserLicense(accessToken, userLicense)
				.then((res) => {
					dispatch(updateUserLicenseSuccess());
					return userLicenseApi
						.clearAuthCachesInDataPlatform(accessToken, userLicense.clientId)
						.then(() => resolve(res));
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function removeUserLicense(accessToken, userLicenseId, clientId) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return userLicenseApi
				.removeUserLicense(accessToken, userLicenseId)
				.then((res) => {
					dispatch(removeUserLicenseSuccess());
					return userLicenseApi.clearAuthCachesInDataPlatform(accessToken, clientId).then(() => resolve(res));
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}
